/* eslint-disable import/prefer-default-export */
import { useCallback, useEffect, useState } from 'react';

import { POSITION_KEY } from '../utils/consts';
import { getLinesByPosition } from '../../../services/adminContracts';
import { tryCatchMaker } from '../../../utils/globalFunctions';
import useToast from '../../../hooks/useToast';

export const usePositionLineForm = ({
  filters,
  currentContractsSelected,
  setErrorPositionLine
}) => {
  const { setNewToast } = useToast();
  const [{ position, line, positionLine }, setPositionLine] = useState({
    position: '',
    line: '',
    positionLine: filters.posicionesLineas ?? []
  });
  const [linesOptions, setLinesOptions] = useState([]);

  useEffect(() => {
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: filters.posicionesLineas ?? []
    }));
  }, [filters?.posicionesLineas]);

  const handlePositionLineChange = useCallback(
    (key, newValue) => {
      if (POSITION_KEY === key) {
        if (newValue) {
          tryCatchMaker({
            promise: () => getLinesByPosition(currentContractsSelected, newValue.nombre),
            defaultValue: [],
            setNewToast
          }).then((data) => {
            setLinesOptions(data);
          });
        }

        return setPositionLine((prevState) => ({
          ...prevState,
          line: '',
          [key]: newValue
        }));
      }

      return setPositionLine((prevState) => ({
        ...prevState,
        [key]: newValue
      }));
    },
    [currentContractsSelected, setNewToast]
  );

  const resetPositionLineChips = useCallback(() => {
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: []
    }));
  }, []);

  const resetPositionAndLineFields = useCallback(() => {
    setPositionLine((prevState) => ({
      position: '',
      line: '',
      positionLine: [...prevState.positionLine]
    }));
  }, []);

  const addPositionLine = useCallback(
    (newValue) => {
      // *This label is for UI requirement
      const positionLineLabel = `P${position.nombre} - L${newValue.nombre}`;

      const positionLineNewValue = {
        label: positionLineLabel,
        value: `${position.nombre}-${newValue.nombre}`
      };

      const hasPositionLine = Object.keys(positionLineNewValue).every(
        (key) => positionLineNewValue[key] !== null
      );

      if (hasPositionLine) {
        const exists = positionLine.some((posLine) => posLine.label === positionLineNewValue.label);

        if (exists) {
          setErrorPositionLine('La posición y línea ya fue seleccionada');

          return;
        }
        setErrorPositionLine('');
        setPositionLine((prevState) => ({
          position: '',
          line: '',
          positionLine: [...prevState.positionLine, positionLineNewValue]
        }));
      }
    },
    [position.nombre, positionLine, setErrorPositionLine]
  );

  const deletePositionLine = useCallback(({ label }) => {
    setErrorPositionLine('');
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: prevState.positionLine.filter((e) => e.label !== label)
    }));
  }, []);

  return {
    handlePositionLineChange,
    resetPositionAndLineFields,
    addPositionLine,
    deletePositionLine,
    resetPositionLineChips,
    positionLine,
    linesOptions,
    position,
    line
  };
};
